<div class="modal-body">
    <cm-display-html class="step-description" [content]="step.description"></cm-display-html>
    <cm-step-on-behalf-list
        *ngIf="step.on_behalf_indicator"
        class="info-section"
        [onBehalfIndicator]="step.on_behalf_indicator"
    ></cm-step-on-behalf-list>
    <form *ngIf="registrationForm" [formGroup]="registrationForm" novalidate autocomplete="off">
        <div class="form-element" *ngFor="let field of savedFields" [ngSwitch]="field.type_id">
            <div
                *ngIf="checkCountryFieldFilled(field)"
                [hidden]="registrationFormFieldsMap[field.field_id].noStates"
                class="form-group"
            >
                <label
                    for="{{ getElementId(field) }}"
                    class="form-label form-label--bold"
                    [class.required]="field.required"
                >
                    {{ field.name }}
                </label>
                <ng-container *ngSwitchCase="FIELD_TYPES.TEXT">
                    <input
                        id="{{ getElementId(field) }}"
                        type="text"
                        [formControlName]="field.field_id"
                        class="form-control"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    />
                </ng-container>
                <ng-container *ngSwitchCase="FIELD_TYPES.RADIO">
                    <cm-radio-group
                        [formControlName]="field.field_id"
                        [options]="registrationFormFieldsMap[field.field_id].options"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    >
                    </cm-radio-group>
                </ng-container>
                <ng-container *ngSwitchCase="FIELD_TYPES.CHECKBOX">
                    <cm-checkbox-group
                        [formControlName]="field.field_id"
                        [options]="registrationFormFieldsMap[field.field_id].options"
                        [required]="field.required"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    >
                    </cm-checkbox-group>
                </ng-container>
                <ng-container *ngSwitchCase="FIELD_TYPES.SELECT">
                    <cm-select
                        id="{{ getElementId(field) }}"
                        [formControlName]="field.field_id"
                        [options]="registrationFormFieldsMap[field.field_id].options"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    >
                    </cm-select>
                </ng-container>

                <ng-container *ngSwitchCase="FIELD_TYPES.EMAIL">
                    <input
                        type="email"
                        id="{{ getElementId(field) }}"
                        [formControlName]="field.field_id"
                        class="form-control"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    />
                </ng-container>
                <ng-container *ngSwitchCase="FIELD_TYPES.NUMBER">
                    <cm-number-input
                        [formControlName]="field.field_id"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    >
                    </cm-number-input>
                </ng-container>
                <ng-container *ngSwitchCase="FIELD_TYPES.DATE">
                    <cm-datepicker
                        id="{{ getElementId(field) }}"
                        [useDeprecatedDateOutputFormat]="true"
                        [formControlName]="field.field_id"
                        [minDate]="getDatepickerMinDate(field)"
                        [maxDate]="getDatepickerMaxDate(field)"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    >
                    </cm-datepicker>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <input
                        id="{{ getElementId(field) }}"
                        type="text"
                        [formControlName]="field.field_id"
                        class="form-control"
                        [class.is-invalid]="registrationForm.controls[field.field_id].errors && showErrors"
                    />
                </ng-container>
            </div>
        </div>
    </form>
    <div class="form-errors" [ngClass]="{ 'show-errors': showErrors }">
        <p *ngIf="showRequiredError">Please fill in all required fields.</p>
        <p *ngIf="showEmailError">Please enter the valid email.</p>
    </div>
</div>
<div class="modal-footer">
    <button *ngIf="!isStepSubmitted" type="button" class="btn btn-default" (click)="backToMainPage()">Back</button>
    <button *ngIf="!isStepSubmitted" type="button" class="btn btn-primary" (click)="submitForm()">Submit</button>
    <button *ngIf="isStepSubmitted" type="button" class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
